import React, { useState } from 'react';
import styles from '../../styles/hardware/hardware.module.css';
import ReactTyped from 'react-typed';
import Image from 'next/image';
import { AdvanceAnalyticsBanner, AndroidPOSBenifits, BlackCustomButton, MarqueeComponentHomePage, TransparentCustomButton, WhiteCustomButton } from '../qbStrap';
import ThreeStepForm from '../common/ThreeStepForm';
import TestimonialSection from '../common/TestimonialSection';
import { ClientsArr1, hardwareDevices, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import TrustFactor from '../common/TrustFactor';
import FrequentQuestions from '../homePage/FrequentQuestions';
import { hardwareFaq } from '@/constants/industry';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import POS from 'public/assets/hardware/POS';
import Printer from 'public/assets/hardware/Printer';
import CashDrawer from 'public/assets/hardware/CashDrawer';
import Barcode from 'public/assets/hardware/Barcode';
import WeighingScale from 'public/assets/hardware/WeighingScale';
import Link from 'next/link';
import { LuArrowUpRight } from "react-icons/lu";
import VerificationPopup from '../modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../language/ENGLISH.json';

const DesktopHardware = () => {
    const [selectedDevice, setSelectedDevice] = useState(0);
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <h1>
                        <span className={styles.small_black_text}>The Right Hardware is</span><br />
                        <span className={styles.black_text}>Essential for </span><br /> <span className={styles.blue_text}><ReactTyped strings={["Growth", "Business Operations", "Efficiency"]} typeSpeed={200} loop /></span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster POS seamlessly integrates with all Android devices, streamlining operations and maximizing efficiency. With easy setup and versatile compatibility, businesses can leverage their preferred Android hardware for optimal point-of-sale performance.</p>
                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try it Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img_container}>
                    <div className={styles.hero_img}><Image src="/assets/hardware-partners/hero-img.webp" alt="hardware hero img" fill /></div>
                </div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.all_devices}>
                <div className={styles.stack1}>
                    <div className={styles.choosing_section}>
                        <h3>Compatible With All POS Hardware</h3>
                        {
                            hardwareDevices?.map((ele, idx) => {
                                return (
                                    <div key={ele?.id} onClick={() => setSelectedDevice(idx)} className={`${styles.device} ${selectedDevice === idx && styles.selected_device}`}>
                                        {
                                            ele?.device === "Android POS Machines" ?
                                                <POS color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                ele?.device === "Printers" ?
                                                    <Printer color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                    ele?.device === "Cash Drawers" ?
                                                        <CashDrawer color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                        ele?.device === "Barcode Scanners" ?
                                                            <Barcode color={selectedDevice === idx ? "#2a6ab4" : "#fff"} /> :
                                                            ele?.device === "Weighing Scales" ?
                                                                <WeighingScale color={selectedDevice === idx ? "#2a6ab4" : "#fff"} />
                                                                : <></>
                                        }
                                        <div>
                                            <h4>{`${ele?.device}`}</h4>
                                            <p>{ele?.desc}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={styles.device_container}>
                        {
                            hardwareDevices[selectedDevice]?.deviceArr?.map((ele) => {
                                return (
                                    <div className={styles.hardware_device} onClick={()=> router.push(ele?.link)}>
                                        <div className={styles.hardware_device_img} style={{ height: ele?.height, width: ele?.width }}><Image src={ele?.image} alt={ele?.id} fill /></div>
                                        {/* <p>{ele?.deviceDesc.substring(0, 55)}...</p> */}
                                        <Link href={ele?.link} className={styles.navigtaion_link}>Learn More &nbsp;<LuArrowUpRight /></Link>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className={styles.stack2}></div>
                <div className={styles.stack3}></div>
            </div>

            <AndroidPOSBenifits setDemoModal={setDemoModal} setHeading={setHeading} />

            <div className={styles.good_hardware}>
                <div className={styles.text_section}>
                    <h4>Why Does Your Hardware  Need a Robust POS Solution?</h4>
                    <ul className={styles.list_container}>
                        <li>Upgrading your hardware can help streamline your retail operations, making them more efficient and smoother.</li>
                        <li>Optimal hardware can improve the customer experience by providing them with faster and more accurate service.</li>
                        <li>Use QueueBuster POS software to get real-time analytics and gain valuable insights into your business operations.</li>
                        <li>Reliable and fast hardware can reduce transaction times, allowing you to serve more customers in less time.</li>
                        <li>By reducing the size of your hardware, you can free up valuable shelf space that can be used to display more products, ultimately resulting in more sales.</li>
                    </ul>
                </div>
                <div className={styles.hardware_img}><Image src="/assets/hardware/hardware.svg" alt="Android POS Software" fill /></div>
            </div>

            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />

            <div className={styles.why_qbPOS}>
                <div className={styles.text_section}>
                    <h4 className={styles.why_qbPOS_heading}>Why do Businesses Invest in a POS Billing Solution?</h4>
                    <ul className={styles.list_container}>
                        <li><b>Efficient Transaction Processing:</b> With POS devices, businesses can easily process customer transactions. These systems come equipped with advanced features, such as barcode scanning and receipt printing.</li>
                        <li><b>Inventory Management:</b> A reliable POS system offers comprehensive inventory management capabilities. It allows businesses to track stock levels, monitor product performance.</li>
                        <li><b>Streamlined Operations:</b> POS machines streamline various operational processes, enabling businesses to save time and effort. These systems integrate seamlessly with other business software, such as accounting and customer relationship management (CRM) tools.</li>
                    </ul>
                </div>
            <div className={styles.qbPOS_device}><Image src="/assets/hardware/why_qbPOS_device.webp" alt="Android POS Software" fill /></div>
            </div>

            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={hardwareFaq} heading={"FAQs for Hardware Compatibility of QueueBuster POS"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopHardware